<template>
  <div>
    <!-- Start: Header -->
    <section class="section-header-info">
      <div class="container">
        <div class="row">
          <div class="col-sm-12">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item">
                  <a href="javascript:void(0)">Administration</a>
                </li>
                <li class="breadcrumb-item active" aria-current="page">
                  Pick-up Offset
                </li>
              </ol>
            </nav>

            <div class="row" style="padding: 20px 0">
              <div class="col-sm-12">
                <div class="inline-form">
                  <label for="default-ofset">Default Offset</label>
                  <input
                    type="text"
                    class="form-control numbers-only"
                    id="default-offset"
                    autocomplete="off"
                    v-model="minuteOffset"
                    placeholder="Enter a Default Minute Offset"
                  />
                  <button
                    class="btn btn-primary"
                    :disabled="
                      minuteOffset === null ||
                      minuteOffset === '' ||
                      minuteOffset === undefined
                    "
                    @click="updateDefaultOffset()"
                    type="button"
                  >
                    Update
                  </button>
                </div>
              </div>
            </div>

            <div class="content-header-info">
              <div class="col-sm-12">
                <button
                  v-if="isAllowToCreate"
                  class="btn btn-primary pull-left"
                  @click="createItem()"
                >
                  <span>&#43;</span> Create New
                </button>
                <div class="pl-30 pull-left">
                  <h2>
                    Pick-up Offset Time by Company<span
                      ><i class="ic-time"></i
                    ></span>
                  </h2>
                  <p>
                    Manage pick-up offset data as part of your business
                    offering.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- End: Header -->

    <!-- Start: Table -->
    <section class="middle-content">
      <div class="container">
        <div class="row hidden">
          <div class="col-sm-6">
            <div class="dataTables_filter">
              <i class="ic-search"></i>
              <input
                type="search"
                class="form-control"
                v-model="table.keyword"
                @keyup="onKeyupKeyword()"
                placeholder="Search Company Name, Phone or Email"
              />
            </div>
          </div>
          <div class="col-sm-6">
            <div class="dataTables_length pull-right">
              <label>
                <select
                  class="form-control v-select"
                  v-model="table.pageSize"
                  @change="onChangePageSize()"
                >
                  <option
                    v-for="item in table.pageSizes"
                    :value="item"
                    :key="item"
                  >
                    {{ item }}
                  </option>
                </select>
                Entries</label
              >
            </div>
          </div>
        </div>
        <div class="row">
          <div class="table-p15">
            <table class="table table-hover table-fix">
              <thead>
                <tr>
                  <th>Offset Time (Minutes)</th>
                  <th>Companies</th>
                  <th class="text-center">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr class="detail-row" v-for="item in items" :key="item.id">
                  <td>{{ item.minuteOffset }}</td>
                  <td>
                    <span
                      :class="{ 'sts-danger': item.companies.length === 0 }"
                      >{{ printCompanies(item.companies) }}</span
                    >
                    <button
                      class="btn-view"
                      v-if="item.companies.length > 1"
                      @click="openModalViewCompany(item.companies)"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        viewBox="0 0 576 512"
                      >
                        <path
                          d="M572.52 241.4C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48 241.41a32.35 32.35 0 0 0 0 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 0 0 0-29.19zM288 400a144 144 0 1 1 144-144a143.93 143.93 0 0 1-144 144zm0-240a95.31 95.31 0 0 0-25.31 3.79a47.85 47.85 0 0 1-66.9 66.9A95.78 95.78 0 1 0 288 160z"
                          fill="currentColor"
                        ></path>
                      </svg>
                    </button>
                  </td>
                  <td class="text-center">
                    <div class="button-action-wrapper">
                      <button
                        v-if="isAllowToUpdate"
                        class="btn btn-default"
                        type="button"
                        @click="updateItem(item)"
                      >
                        <span>Edit</span>
                      </button>
                      <button
                        v-if="isAllowToDelete"
                        class="btn btn-default"
                        type="button"
                        @click="confirmDelete(item)"
                      >
                        <i class="ic-close"></i>
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-5">
            <div class="dataTables_info --blue25">
              <strong>{{ recordInfo }}</strong>
            </div>
          </div>
          <div class="col-sm-7">
            <nav aria-label="...">
              <paginate
                v-model="table.pageNumber"
                :page-count="table.totalPages"
                :click-handler="onNavigateCallback"
                :prev-text="'Previous'"
                :next-text="'Next'"
                :container-class="'pagination pull-right'"
              >
              </paginate>
            </nav>
          </div>
        </div>
      </div>
    </section>
    <!-- End: Table -->

    <!-- Start: Modal -->
    <div class="modal fade" role="dialog" ref="regionmodal">
      <div class="modal-dialog modal-sm">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header modal-new" :class="{ update: isUpdate }">
            <div class="row">
              <div class="col-sm-10">
                <h4>Pick-up Offset</h4>
                <h6 v-if="model.modifiedDate">
                  Last Updated: {{ model.modifiedDate.stringFullDate }}
                </h6>
              </div>
              <div class="col-sm-2">
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <i class="ic-close"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="modal-body">
            <div class="modal-wrapper">
              <div class="col-sm-12">
                <div class="modal-content-body">
                  <div class="summary-error" v-if="$v.model.$error">
                    This form has errors
                  </div>
                  <form @submit.prevent="submit">
                    <div class="form-group">
                      <label class="required">Minute Offset</label>
                      <input
                        type="text"
                        class="form-control numbers-only"
                        :class="{
                          'field-error':
                            isSubmitted && $v.model.minuteOffset.$error,
                        }"
                        autocomplete="off"
                        v-model="model.minuteOffset"
                        placeholder="Enter a Minute Offset"
                      />
                      <div v-if="isSubmitted && $v.model.minuteOffset.$error">
                        <small
                          class="form-text sts-danger"
                          v-if="!$v.model.minuteOffset.required"
                          >Minute Offset is required</small
                        >
                      </div>
                    </div>
                    <div class="form-group">
                      <label class="required">Companies</label>
                      <multiselect
                        :class="{
                          'field-error':
                            isSubmitted && $v.model.companies.$error,
                        }"
                        v-model="model.companies"
                        :multiple="true"
                        :close-on-select="false"
                        :options="companies"
                        placeholder="Select Companies"
                        label="name"
                        track-by="id"
                      ></multiselect>
                      <small
                        class="form-text sts-danger"
                        v-if="isSubmitted && !$v.model.companies.required"
                        >Country is required</small
                      >
                    </div>
                    <div class="modal-footer">
                      <button type="submit" class="btn btn-primary">
                        {{ isUpdate ? "Save Changes" : "Save" }}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <!-- /.modal-wrapper -->
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" role="dialog" ref="viewcompanymodal">
      <div class="modal-dialog modal-sm">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-body repricing-modal">
            <div class="row">
              <div class="col-sm-12">
                <div class="d-flex justify-between items-center">
                  <h4>Companies</h4>
                  <button
                    type="button"
                    class="close btn-close-modal"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <i class="ic-close"></i>
                  </button>
                </div>
              </div>
              <div class="col-sm-12">
                <div
                  class="company-box"
                  v-for="company in companySelected"
                  :key="company.id"
                >
                  <div class="building-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      viewBox="0 0 448 512"
                    >
                      <path
                        d="M436 480h-20V24c0-13.255-10.745-24-24-24H56C42.745 0 32 10.745 32 24v456H12c-6.627 0-12 5.373-12 12v20h448v-20c0-6.627-5.373-12-12-12zM128 76c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12V76zm0 96c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12v-40zm52 148h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12zm76 160h-64v-84c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v84zm64-172c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40zm0-96c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40zm0-96c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12V76c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40z"
                        fill="currentColor"
                      ></path>
                    </svg>
                  </div>
                  <span class="company-text">{{ company.name }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <deleteModal @submit="submitDelete" />
    <!-- End: Modal -->

    <!-- Start: BlockUI -->
    <loader :content="msg" :visible="isLoading" />
    <!-- End: BlockUI -->
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import deleteModal from "@/components/shared/DeleteModal";
import pickupOffsetService from "@/services/master/pickupOffset/pickupOffsetService.js";
import companyService from "@/services/master/company/companyService.js";

export default {
  components: {
    deleteModal,
  },
  computed: {
    isAllowToRead: function () {
      return this.allPermissions.includes("Read");
    },
    isAllowToCreate: function () {
      return this.allPermissions.includes("Create");
    },
    isAllowToUpdate: function () {
      return this.allPermissions.includes("Update");
    },
    isAllowToDelete: function () {
      return this.allPermissions.includes("Delete");
    },
    recordInfo: function () {
      return this.table.totalRecords > 1
        ? `${this.table.totalRecords} Records`
        : `${this.table.totalRecords} Record`;
    },
  },
  data() {
    return {
      table: {
        keyword: "",
        totalPages: 1,
        totalRecords: 0,
        pageNumber: 1,
        pageSize: 25,
        pageSizes: [25, 50, 100],
        sort: "",
        sortDir: "",
      },
      companySelected: [],
      companies: [],
      minuteOffset: null,
      isSubmitted: false,
      allPermissions: [],
      itemToBeDeleted: null,
      items: [],
      model: {},
      isLoading: false,
      isUpdate: false,
      msg: "Please wait",
    };
  },
  validations() {
    return {
      model: {
        minuteOffset: { required },
        companies: { required },
      },
    };
  },
  async created() {
    this.$helper.scrollTop();
    const publicSettings = await this.$store.dispatch("setting/getAllPublic");
    this.table.pageSize = this.$helper.extractSetting(
      publicSettings,
      "PageSize",
      25
    );

    const profile = await this.$store.dispatch("user/getProfile");
    const permissions = profile.services[this.$route.name];
    if (permissions) {
      this.allPermissions = permissions;
    }

    if (this.isAllowToRead) {
      this.getDefaultOffset();
      await this.getAll();
      this.getCompanies();
    }
  },
  mounted() {
    $(this.$refs.regionmodal).on("hidden.bs.modal", this.closeModal);
  },
  updated() {
    this.$helper.collapseMenu("administration");
    this.$helper.setNavigationClass("pickup-offset-link");
    this.$helper.numbersOnly();
  },
  methods: {
    async getDefaultOffset() {
      try {
        const response = await pickupOffsetService.getDefaultOffset();
        if (response.isSuccess) {
          this.minuteOffset = response.data.minuteOffset;
        }
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      }
    },
    async getCompanies() {
      try {
        this.companies = await companyService.getAllActive();
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      }
    },
    async updateDefaultOffset() {
      this.isLoading = true;
      try {
        await pickupOffsetService.updateDefaultOffset({
          minuteOffset: Number(this.minuteOffset),
        });
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.getDefaultOffset();
        this.isLoading = false;
      }
    },
    async onChangePageSize() {
      this.table.pageNumber = 1;
      await this.getAll();
    },
    async onKeyupKeyword() {
      const self = this;
      if (self.timer) {
        clearTimeout(self.timer);
        self.timer = null;
      }
      self.timer = setTimeout(async (_) => {
        self.table.pageNumber = 1;
        await self.getAll();
      }, 500);
    },
    async onNavigateCallback(pageNumber) {
      this.table.pageNumber = pageNumber;
      await this.getAll();
    },
    resetModel() {
      this.model = {};
    },
    resetValidations() {
      this.isSubmitted = false;
      this.$v.model.$reset();
    },
    openModalViewCompany(companies) {
      this.companySelected = companies;
      $(this.$refs.viewcompanymodal).modal({
        backdrop: "static",
        keyboard: false,
      });
    },
    // closeModalViewCompany() {
    //   $(this.$refs.viewcompanymodal).modal("hide");
    // },
    openModal(object) {
      this.resetValidations();
      this.model = Object.assign({}, object);
      $(this.$refs.regionmodal).modal({ backdrop: "static", keyboard: false });
    },
    closeModal() {
      this.isUpdate = false;
      this.resetModel();
      this.resetValidations();
      $(this.$refs.regionmodal).modal("hide");
    },
    createItem() {
      this.isUpdate = false;
      this.resetModel();
      this.openModal({ minuteOffset: null, companies: [] });
    },
    updateItem(item) {
      const objectData = {
        id: item.id,
        minuteOffset: item.minuteOffset,
        companies: item.companies,
        modifiedDate: item.modifiedDate,
      };
      this.isUpdate = true;
      this.openModal(objectData);
    },
    async getAll() {
      if (!this.isAllowToRead) {
        return;
      }
      this.isLoading = true;
      try {
        let filter = `?page=${this.table.pageNumber}&pageSize=${this.table.pageSize}`;
        const response = await pickupOffsetService.getAll(filter);
        this.items = response.data.items;
        this.table.totalPages = response.data.totalPages;
        this.table.totalRecords = response.data.totalItems;
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    async submit() {
      this.isSubmitted = true;
      this.$v.model.$touch();
      if (this.$v.model.$error) {
        return;
      }
      try {
        this.isLoading = true;
        const payload = {
          ...this.model,
          minuteOffset: Number(this.model.minuteOffset),
          companies: this.model.companies.map((val) => val.id),
        };
        if (this.isUpdate) {
          await pickupOffsetService.update(payload);
          this.$notification.success("Successfully updated.", {
            title: "Success",
          });
        } else {
          await pickupOffsetService.create(payload);
          this.$notification.success("Successfully added.", {
            title: "Success",
          });
        }
        await this.getAll();
        this.closeModal();
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    confirmDelete(item) {
      this.itemToBeDeleted = item;
      $("#deletemodal").modal();
    },
    async submitDelete() {
      try {
        this.isLoading = true;
        await pickupOffsetService.delete(this.itemToBeDeleted.id);
        this.$notification.success("Successfully deleted.", {
          title: "Success",
        });
        await this.getAll();
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    printCompanies(companies) {
      if (companies.length === 0) {
        return "N/A";
      } else if (companies.length === 1) {
        return companies[0].name;
      } else {
        return `${companies.length} companies`;
      }
    },
  },
};
</script>
<style scoped>
.btn-view {
  padding: 3px 7px;
  border: none;
  border-radius: 3px;
  margin-left: 3px;
}

.btn-view svg {
  width: 13px;
  height: 13px;
}
</style>



// WEBPACK FOOTER //
// src/components/master/pickupOffset/pickupOffset.vue